export default __webpack_public_path__ + "static/media/pups-logo-branco.36cb28f1.png";